export const urlDomain = () => {
  // Map the hostnames to their corresponding API URLs
  const hostDomainMap = {
    "vendors.intermesh.net": "https://vendors.intermesh.net/api",
    "beta-vendors.intermesh.net": "https://beta-vendors.intermesh.net/api",
    "dev-vendors.intermesh.net": "https://dev-vendors.intermesh.net/api",
  };
  // Return the API URL based on the current host, default to localhost if not found
  return hostDomainMap[window.location.host] || "http://localhost:1300/api";
};